export default __webpack_public_path__ + "static/media/fixedold-after.245a0b7d.png";